// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".round[data-v-05e809ed]{border-radius:10px}.bg-grey[data-v-05e809ed]{background-color:#e8e8e8}a[data-v-05e809ed]{color:#1ad596}.btn-c[data-v-05e809ed]{font-weight:500;border-radius:18px}.btn-c.add[data-v-05e809ed]{border-color:#000}.btn-c.delete[data-v-05e809ed]{background-color:#dc3545;border-color:#dc3545}.c-space[data-v-05e809ed]{margin-bottom:2px}.c-disconnect[data-v-05e809ed]{color:gray;background-color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
